import { render, staticRenderFns } from "./itemWithLabel.vue?vue&type=template&id=d07176e4&scoped=true"
import script from "./itemWithLabel.vue?vue&type=script&lang=js"
export * from "./itemWithLabel.vue?vue&type=script&lang=js"
import style0 from "./itemWithLabel.vue?vue&type=style&index=0&id=d07176e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07176e4",
  null
  
)

export default component.exports